import { useEffect, useState } from "react";

import { Panel } from "@src/features/experienceBuilder/modifications/common/panel/Panel";

import { InputProps } from "./types";

const PX_REGEX = /^\d+(\.\d+)?px$/;
const BARE_NUMBER = /^\d+(\.\d+)?$/;

const normalize = (v: string) => (BARE_NUMBER.test(v) ? `${v}px` : v);
const isValid = (v: string) => v === "" || PX_REGEX.test(normalize(v));

export const PixelInput = ({ label, value, onChange }: InputProps) => {
  const [localValue, setLocalValue] = useState(value);

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  const commit = (val: string) => {
    const normalized = normalize(val);
    if (isValid(val)) {
      onChange(normalized);
      setLocalValue(normalized);
    } else {
      setLocalValue(value);
    }
  };

  return (
    <Panel.TextField
      label={label}
      placeholder="e.g. 16px"
      value={localValue}
      onChange={(e) => setLocalValue(e.target.value)}
      onBlur={() => commit(localValue)}
      onKeyDown={(e) => {
        if (e.key === "Enter") commit(localValue);
      }}
      error={localValue !== "" && !isValid(localValue)}
      helperText={
        localValue !== "" && !isValid(localValue) ? "e.g. 16px" : undefined
      }
    />
  );
};
